<script>
  import { getContext } from "svelte";
  import DeleteButton from "./DeleteButton.svelte";
  import Filter from "./Filter.svelte";

  export let filters = [];
  export let deleteDisabled = false;
  export let config;

  const isChildTable = getContext("isChildTable");
</script>

{#if !isChildTable && filters.length > 0}
  <div
    class="flex flex-row justify-betweeen items-center py-4 w-full bg-white rounded-md mb-2 mt-1 px-4"
  >
    <Filter {filters} on:filterChange />
    {#if config.showCheckboxes && config.enableDeleteAll}
      <DeleteButton label="Delete" disabled={deleteDisabled} on:delete />
    {/if}
  </div>
{/if}
